<template>
  <v-dialog
    v-if="hasEditor"
    v-model="dialog"
    :max-width="dialogMaxWidth"
    content-class="sc-modal sc-modal--md"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        fab
        small
        class="edit-media-btn"
        :aria-label="`Editar ${activatorLabel}`"
        @click="dialog = true"
      >
        <v-icon color="icon_default" small>{{ activatorIcon }}</v-icon>
      </v-btn>
    </template>

    <component
      :is="editorComponent"
      v-if="dialog"
      :media="media"
      :num_coluna_telao="num_coluna_telao"
      @close="dialog = false"
      @saved="$emit('saved')"
    />
  </v-dialog>
</template>

<script>
// Add a new editor by registering it here and the dispatcher picks it up.
// Each editor must accept `:media` and `:num_coluna_telao`, and emit
// `@close` (always) and `@saved` (after a successful save).
const EDITOR_REGISTRY = {
  image: {
    component: () => import("./editors/EditorImagemColaboracao.vue"),
    icon: "mdi-pencil",
    label: "imagem",
    maxWidth: 630,
  },
  // video: {
  //   component: () => import("./editors/EditorVideoColaboracao.vue"),
  //   icon: "mdi-content-cut",
  //   label: "vídeo",
  //   maxWidth: 800,
  // },
  // audio: {
  //   component: () => import("./editors/EditorAudioColaboracao.vue"),
  //   icon: "mdi-waveform",
  //   label: "áudio",
  //   maxWidth: 630,
  // },
};

export default {
  name: "ModalEditarMidiaColaboracao",
  props: {
    media: { type: Object, required: true },
    num_coluna_telao: { type: Number, default: null },
  },
  data() {
    return { dialog: false };
  },
  computed: {
    editorConfig() {
      return EDITOR_REGISTRY[this.media.dsc_tipo_midia_colaboracao] || null;
    },
    hasEditor() {
      return this.editorConfig !== null;
    },
    editorComponent() {
      return this.editorConfig?.component;
    },
    activatorIcon() {
      return this.editorConfig?.icon || "mdi-pencil";
    },
    activatorLabel() {
      return this.editorConfig?.label || "mídia";
    },
    dialogMaxWidth() {
      return this.editorConfig?.maxWidth || 630;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-media-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(4px);
  width: 24px;
  height: 24px;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 var(--sc-radius-md) 0 var(--sc-radius-sm);

  .v-icon {
    font-size: 14px !important;
  }
}
</style>
